export default "__VITE_ASSET__DLh9qAEp__"